import React from 'react';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import NotesIcon from '@material-ui/icons/Notes';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Link } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Slide from '@material-ui/core/Slide';

import logo from '../../static/images/logo.png';

function HideOnScroll(props) {
  const { children } = props;
  
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        background: "rgba(0,0,0,0.4)",
        boxShadow: "none"
    },
    title: {
        position: "relative",
        flexGrow: 1,
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,

    },
    drawerPaper: {
        width: drawerWidth,
        background: "rgba(0,0,0,0.77)"
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        color: "white",
    },
    button: {
        textTransform: "none",
    },
    st0: { 
        fill: "white",
        
    }
}));

const NavItem = [
    ["Home", "/", "<InboxIcon />"],
    ["About", "/about", "<MailIcon />"],
    ["Portfolio", '/portfolio'],
    ["Services", "/services"]
]

export default function Header(props) {
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const childProps = {
        open,
        handleDrawerClose,
        handleDrawerOpen
    }

    return (
        <>
            <CssBaseline />
            <Main {...childProps} />
            <Sidebar {...childProps} />       
        </>
    )
}

const Main = (props) => {
    const classes = useStyles();
    let index = 0;
    return (
        <>
            <HideOnScroll {...props}>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <Hidden smUp>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={props.handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, props.open && classes.hide)}
                            >
                                <NotesIcon />
                            </IconButton>
                        </Hidden>
                        <Box className={`${classes.title} ${"wow bounceInDown"}`}>
                            <img src={logo} width="30px" alt="logo.png" />
                        </Box>
                        <Hidden xsDown>
                            {
                                NavItem.map(([value, key, icon]) => {
                                    index += 0.1;
                                    return (
                                        <Button 
                                            key={key}
                                            color="inherit" 
                                            component={Link} 
                                            to={key} 
                                            className={`${classes.button} ${"wow bounceInDown"}`}
                                            style={{animationDelay: `${index + "s"}`}}
                                        >{value}</Button>
                                    )
                                })
                            }
                        </Hidden>
                        <Button href="mailto:ibisodb@gmail.com" className={`${classes.button} ${"animated"} ${"infinite"} ${"pulse"}`} variant="outlined" disableElevation style={{ borderRadius: "30px", marginLeft: "10px", borderColor: "wheat", color: "wheat" }}>Contact</Button>
                    </Toolbar>
                </AppBar>
            </HideOnScroll>            
        </>
    )
}

const Sidebar = (props) => {
    const classes = useStyles();

    return (
        <Hidden smUp>
            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={props.open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={props.handleDrawerClose} color="inherit">
                        <CloseIcon />
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {NavItem.map(([text, index]) => (
                        <ListItem onClick={props.handleDrawerClose} button key={text} component={Link} to={index}>
                            <ListItemText style={{ color: "white" }} primary={text} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </Hidden>
    )
}